import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.freeze";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

var _Icon, _Icon2, _Icon3, _Icon4, _Icon5;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import classnames from 'classnames';
import { textRemoveHtml } from "../../../utils";
import useBytesPrettier from "../../../hooks/useBytesPrettier";
import Icon from '../Icon/Icon';
import Text from '../../Typography/Text/Text';
import styles from './Attachment.scss';
export var ATTACHMENT_TYPE = Object.freeze({
  file: 'file',
  link: 'link'
});

var getIconForAttachmentType = function getIconForAttachmentType(type) {
  switch (type) {
    case ATTACHMENT_TYPE.file:
      return _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
        size: "extra-large",
        name: "document",
        color: "label"
      }));

    case ATTACHMENT_TYPE.link:
      return _Icon2 || (_Icon2 = /*#__PURE__*/React.createElement(Icon, {
        size: "extra-large",
        name: "link",
        color: "label"
      }));

    default:
      return _Icon3 || (_Icon3 = /*#__PURE__*/React.createElement(Icon, {
        size: "extra-large",
        name: "menu",
        color: "label"
      }));
  }
};

var Attachment = function Attachment(_ref) {
  var type = _ref.type,
      title = _ref.title,
      subtitle = _ref.subtitle,
      size = _ref.size,
      preview = _ref.preview,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      className = _ref.className;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imageError = _useState2[0],
      setImageError = _useState2[1];

  var handleImageError = function handleImageError() {
    setImageError(true);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.Attachment, className, _defineProperty({}, styles.full, isFullWidth), 'iv-attachment')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrap
  }, preview && !imageError ? /*#__PURE__*/React.createElement("img", {
    src: preview,
    alt: textRemoveHtml(title),
    onError: handleImageError
  }) : getIconForAttachmentType(type)), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    className: styles.name
  }, textRemoveHtml(title)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "label",
    className: styles.link
  }, type === ATTACHMENT_TYPE.file && size ? useBytesPrettier(size) : textRemoveHtml(subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.typeIcon
  }, type === ATTACHMENT_TYPE.link && (_Icon4 || (_Icon4 = /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    name: "arrow-link"
  }))), type === ATTACHMENT_TYPE.file && (_Icon5 || (_Icon5 = /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    name: "download"
  }))))));
};

export default Attachment;